/* eslint-disable */
export default {
    props: {
        interval: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            test: '',
            Quiz: null
        };
    },
    mounted() {
        this.openAtTimeout();
        
        this.Quiz = this.$children.find(child => { return child.$options.name === "aha-transition-group"; });
        if(this.Quiz !== undefined) {
            console.log('Quiz component', this.Quiz);
            this.$root.$on('bv::modal::hidden', this.resetQuiz);
        }
        
    },
    methods: {
        openAtTimeout: function() {
            if(this.interval === 0 || this.interval === '') {
                return;
            }
            setTimeout(() => {
                this.show();
            }, this.interval * 1000);
        },
        resetQuiz: function(evt) {
            // Reset quiz back to first step
            this.Quiz.EventBus.$emit('stepTrigger', 1);
        }
    }
};



// WEBPACK FOOTER //
// ./src/app/mixins/extend-aha-modal.js